/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { INSPECTOR_NODE_TYPE, isInspectorNodeDefault, TInspectorNode } from "../InspectorNodeTypes";
import { ISchemaViewRefModel, isSchemaViewRefModel } from "@adapptio/lib-blueprint";
import { mapModelToNodes } from "../index";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { getParentComponentName } from "../utils";

export function viewRefMapper(model: ISchemaViewRefModel): TInspectorNode {
	if (!isSchemaViewRefModel(model)) {
		return;
	}

	const viewIdNode = mapModelToNodes(model.viewId);

	const viewIdControls = isInspectorNodeDefault(viewIdNode) ? viewIdNode.controls : [];

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: model.schema.opts.label,
		tooltip: model.schema.opts.description,
		required: model.schema.opts.constraints?.required || false,
		default: model.schema.opts["default"] || null,
		referenceData: getParentComponentName(model),
		descriptor: mapperDescriptor(model.schema),
		examples: mapperExamples(model.schema),
		options: model.schema.opts["options"],
		deps: [ model, model.params, model.params?.value, ...viewIdNode.deps ],
		controls: [ ...viewIdControls ],
		children: [ () => mapModelToNodes(model?.params) ]
	};
}
